<template>
  <div class="login">
    <el-form
      v-show="loginFlag"
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
      align="center"
    >
      <h3 style="margin-bottom: 20px; margin-top: 30px; text-align: center">
        登录
      </h3>
      <el-form-item prop="username" label-width="auto">
        <el-input
          type="username"
          v-model="ruleForm.username"
          autocomplete="off"
          placeholder="邮箱或者手机号"
          style="width: 50%"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password" label-width="auto">
        <el-input
          type="password"
          v-model="ruleForm.password"
          autocomplete="off"
          placeholder="密码"
          style="width: 50%"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item class="btn-footer">
        <el-row :gutter="20">
          <el-col :span="12" :offset="6">
            <el-button
              type="primary"
              style="width: 100%"
              @click="submitForm('ruleForm')"
              >登 录</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" :offset="6">
            <el-button style="width: 100%" @click="regist('ruleForm')"
              >注 册</el-button
            >
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <Registration v-if="!loginFlag" @loginFlag="changeSatus"></Registration>
  </div>
</template>
<script>
import Registration from './Registration.vue';
// import axios from 'axios';
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.password !== '') {
          this.$refs.ruleForm.validateField('password');
        }
        callback();
      }
    };
    return {
      ruleForm: {
        username: '',
        password: '',
      },
      loginFlag: true,
      rules: {
        username: [{ validator: validatePass, trigger: 'blur' }],
      },
    };
  },

  components: {
    Registration,
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const payload = {
            username: this.ruleForm.username,
            pwd: this.ruleForm.password,
          };
          this.$axios
            .post('wb/index.php/Newicp/login_ic', payload, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
              },
              withCredentials: true,
            })
            .then((res) => {
              if (res.data.status === 1) {
                this.$message({
                  message: '登陆成功',
                  type: 'success',
                });
                this.$router.push('/publicProducts');
              } else {
                this.$message({
                  message: res.data.info,
                  type: 'warning',
                });
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    regist() {
      this.loginFlag = false;
    },
    changeSatus() {
      this.loginFlag = true;
    },
  },
};
</script>
<style>
.login {
  padding-top: 100px;
}
.demo-ruleForm {
  /* border: 1px solid black;
  background: #fff;
  border-radius: 0.7rem;
  padding: 0 20px; */
  width: 600px;
  height: 460px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  margin-top: 50px;
}

.btn-footer .el-row {
  margin: 20px 0;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
